import { render, staticRenderFns } from "./FormRadio.vue?vue&type=template&id=9260458a&scoped=true"
import script from "./FormRadio.vue?vue&type=script&lang=js"
export * from "./FormRadio.vue?vue&type=script&lang=js"
import style0 from "./FormRadio.vue?vue&type=style&index=0&id=9260458a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9260458a",
  null
  
)

export default component.exports